import { render, staticRenderFns } from "./PartNumberCreate.vue?vue&type=template&id=22319794&"
import script from "./PartNumberCreate.vue?vue&type=script&lang=js&"
export * from "./PartNumberCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports